// extracted by mini-css-extract-plugin
export default {"container":"TeamProfileWrapper_container__4zDFB"};